import { render } from "./PickingAssignment.vue?vue&type=template&id=715640e3&scoped=true"
import script from "./PickingAssignment.vue?vue&type=script&lang=js"
export * from "./PickingAssignment.vue?vue&type=script&lang=js"

import "./PickingAssignment.vue?vue&type=style&index=0&id=715640e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715640e3"]])

export default __exports__